import { createPortal } from "react-dom";
import { getPortalLayerTarget } from "./portalRoot";

const Portal = ({ children, layer = "modal" }) => {
  if (typeof document === "undefined" || !children) return null;

  // Modals must escape #root glass (backdrop-filter / transform) so they
  // cover header + sidebars. Toast/picker layers stay in the portal root.
  if (layer === "modal") {
    return createPortal(children, document.body);
  }

  const target = getPortalLayerTarget(layer);
  if (!target) return null;
  return createPortal(children, target);
};

export default Portal;
